import { Model } from './typings.d'
import { requestErrorHandler } from '-/services'
import { Dispatch } from '-/store/index'
import { convertGetUserInfoReturnDataToUser } from '-/utils/adapter'
import { getV1UserById, getV1User } from '-/apis'

const initState = {
  userList: [],
  currentUser: null,
  filter: {
    currentPage: 1,
    pageSize: 10,
    keywords: '',
  },
  total: 0,
}

const user: Model = {
  state: initState,
  reducers: {
    getUserListSuccess(state, payload) {
      return {
        ...state,
        userList: [...payload.list],
        total: payload.total,
      }
    },
    changeFilter(state, filter) {
      return {
        ...state,
        filter: {
          ...filter,
        },
      }
    },
    setCurrentUser(state, userInfo) {
      return {
        ...state,
        currentUser: userInfo,
      }
    },
    resetState() {
      return {
        ...initState,
      }
    },
  },
  effects: (dispatch: Dispatch) => ({
    async getUserList(payload, rootState) {
      const { filter } = rootState.userManagement

      try {
        const {
          data: { list, total },
        } = await getV1User({
          queryStr: filter.keywords,
          page: filter.currentPage,
          limit: filter.pageSize,
        })

        dispatch.userManagement.getUserListSuccess({ list, total })
      } catch (err) {
        requestErrorHandler(err, {
          business: (code, msg) => {
            dispatch.auth.loginFailure(msg)
          },
        })
      }
    },
    async getUserInfo(id) {
      try {
        const { data } = await getV1UserById(id)

        const userInfo = convertGetUserInfoReturnDataToUser(data)

        dispatch.userManagement.setCurrentUser(userInfo)
      } catch (err) {
        requestErrorHandler(err)
      }
    },
  }),
}

export default user
